import React from "react";
import DesktopWorkExperienceEntry from "./contentCards/desktopWorkExperienceEntry";
import { workExperiences } from "../../data";

const DesktopWorkExperience = () => {
  return (
    <div className="text-white">
      <div
        style={{
          fontSize: "3em",
          fontWeight: "300",
          lineHeight: "1.25",
        }}
        className="py-2"
      >
        Work Experience
      </div>
      {workExperiences.map((exp) => (
        <DesktopWorkExperienceEntry key={exp.id} experience={exp} />
      ))}
    </div>
  );
};

export default DesktopWorkExperience;
